import React, { useState } from "react";
import Tooltip from "../Tooltip";

const Accordion = ({
  title = "",
  open = false,
  count = 0,
  showCount = false,
  showDialogue = false,
  rightDialogHandler = () => { },
  leftDialogHandler = () => { },
  icon = null,
  iconTooltip = "View Details",
  children,
  leftIcon = null,
  leftIconTooltip = "View Details",
  size = "md", // "sm", "md", "lg"
}) => {
  const [isOpen, setIsOpen] = useState(open || false);

  // Size-based classes
  const sizeClasses = {
    sm: {
      padding: "p-1",
      title: "text-sm",
    },
    md: {
      padding: "p-2",
      title: "text-lg",
    },
    lg: {
      padding: "p-3",
      title: "text-xl",
    },
  };

  const currentSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className="border rounded">
      <div
        className={`flex justify-between items-center ${currentSize.padding} cursor-pointer bg-gray-100`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex gap-7 items-center">
          {leftIcon ? (
            <Tooltip
              content={leftIconTooltip || "View Details"}
              position="right"
              className="cursor-pointer"
            >
              <span
                className="cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                  leftDialogHandler();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.stopPropagation();
                    leftDialogHandler();
                  }
                }}
              >
                {leftIcon}
              </span>
            </Tooltip>
          ) : null}
          <div className="flex gap-2 items-center">
            <h2 className={`${currentSize.title} font-medium`}>{title}</h2>
            {showCount ? <span className="text-sm">({count || 0})</span> : null}
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {showDialogue ? (
            <Tooltip
              content={iconTooltip || "View Details"}
              position="left"
              className="cursor-pointer"
            >
              <span
                className="cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                  rightDialogHandler();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.stopPropagation();
                    rightDialogHandler();
                  }
                }}
              >
                {icon}
              </span>
            </Tooltip>
          ) : null}
          <svg
            className={`w-6 h-6 transition-transform transform ${isOpen ? "rotate-180" : "rotate-0"
              }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>
      {isOpen && <div className="p-2">{children}</div>}
    </div>
  );
};

export default Accordion;
